import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4f52a38e&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eaa621c2599a96d5b6a0fac765048019/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f52a38e",
  null
  
)

export default component.exports